export default "__VITE_ASSET__BFdQRgz2__"